import { eTipoPermissao } from '@/enums/ePermissoes';

export default [
 {
  description: 'Movimento Estoque Escola',
  path: '/merenda/mermovimentoestoqueescola',
  name: 'mermovimentoestoqueescola',
  component: () => import('@/views/merenda/mermovimentoestoqueescola/Index.vue'),
  meta: {
   permissions: [eTipoPermissao.MOVIMENTACAOESTOQUEESCOLANOVO_MENU_1900200499],
   alimentacao: false,
  },
  goesToMenu: true,
 },
 {
  description: 'Cadastro de Movimento Estoque Escola',
  path: '/merenda/mermovimentoestoqueescola/cadastro/:id?',
  parent: 'mermovimentoestoqueescola',
  name: 'mermovimentoestoqueescola_create',
  component: () => import('@/views/merenda/mermovimentoestoqueescola/IncluirEditar.vue'),
  meta: {
   permissions: [eTipoPermissao.MOVIMENTACAOESTOQUEESCOLANOVO_MENU_1900200499],
   alimentacao: false,
  },
  goesToMenu: true,
 },
 {
  description: 'Itens do Movimento Estoque Escola',
  path: '/merenda/mermovimentoestoqueescola/:id/itens',
  parent: 'mermovimentoestoqueescola',
  name: 'mermovimentoestoqueescola_itens',
  component: () => import('@/views/merenda/mermovimentoestoqueescola/Itens.vue'),
  meta: {
   permissions: [eTipoPermissao.MOVIMENTACAOESTOQUEESCOLANOVO_MENU_1900200499],
   alimentacao: false,
  },
  goesToMenu: false,
 },
 {
  description: 'Movimento Estoque Escola Alimentacao',
  path: '/merenda/mermovimentoestoqueescolaalimentacao',
  name: 'mermovimentoestoqueescolaalimentacao',
  component: () => import('@/views/merenda/mermovimentoestoqueescola/Index.vue'),
  meta: {
   permissions: [eTipoPermissao.MOVIMENTACAOALIMENTACAONOVO_MENU_1000300499],
   alimentacao: true,
  },
  goesToMenu: true,
 },
 {
  description: 'Cadastro de Movimento Estoque Escola Alimentacao',
  path: '/merenda/mermovimentoestoqueescolaalimentacao/cadastro/:id?',
  parent: 'mermovimentoestoqueescolaalimentacao',
  name: 'mermovimentoestoqueescolaalimentacao_create',
  component: () => import('@/views/merenda/mermovimentoestoqueescola/IncluirEditar.vue'),
  meta: {
   permissions: [eTipoPermissao.MOVIMENTACAOALIMENTACAONOVO_MENU_1000300499],
   alimentacao: true,
  },
  goesToMenu: true,
 },
 {
  description: 'Itens do Movimento Estoque Escola Alimentacao',
  path: '/merenda/mermovimentoestoqueescolaalimentacao/:id/itens',
  parent: 'mermovimentoestoqueescolaalimentacao',
  name: 'mermovimentoestoqueescolaalimentacao_itens',
  component: () => import('@/views/merenda/mermovimentoestoqueescola/Itens.vue'),
  meta: {
   permissions: [eTipoPermissao.MOVIMENTACAOALIMENTACAONOVO_MENU_1000300499],
   alimentacao: true,
  },
  goesToMenu: false,
 },
]
